import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { DialogActions, DialogContent, DialogContentText } from '@mui/material';
import Button from '@mui/material/Button';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import React from 'react';

type Props = {
  readonly isOpen: boolean;
  readonly schemaName: string;
  readonly onConfirmClick: () => void;
  readonly onCancelClick: () => void;
};

const SchemaDeleteDialog = (props: Props) => {
  const {
    isOpen,
    schemaName,
    onCancelClick,
    onConfirmClick,
  } = props;

  return (
    <Dialog
      open={isOpen}
      onClose={onCancelClick}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Delete schema
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete schema with <strong>{schemaName}</strong> name?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancelClick} color='inherit'>Cancel</Button>
        <Button startIcon={<DeleteForeverIcon />} color='primary' onClick={onConfirmClick}>
          Delete schema
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SchemaDeleteDialog;
